import React from 'react'
import find from 'lodash/find'
import FormSelect from 'components/forms/bases/FormSelect'
import { withFontFamilies } from 'store/preferences/withPreferences'

const FontWeightSelector = ({
  currentFamily,
  fontFamily,
  value,
  onChange,
}) => {
  const defaultOptions = [
    {
      label: 'Regular',
      value: 400,
    },
    {
      label: 'Bold',
      value: 700,
    },
  ]
  const family = find(fontFamily, (item) => item.value === currentFamily)
  const options = family && family.weights ? family.weights : defaultOptions
  return (
    <FormSelect
      label="Weight"
      value={value || 400}
      onChange={onChange}
      options={options}
    />
  )
}

FontWeightSelector.propTypes = {}
FontWeightSelector.defaultProps = {}

export default withFontFamilies()(FontWeightSelector)



// WEBPACK FOOTER //
// ./src/components/forms/FontWeightSelector.js